import styled from 'styled-components';
import {p} from 'styles/fragments';

export default styled.p`
	${p};
`;
